import { createContext } from 'react'

export interface IAssignContractorsTableContext {
  tagsFilter: Array<string>
  setTagsFilter(tagsFilter: Array<string>): void

  searchQuery: string
  setSearchQuery(value: string): void
}

export const AssignContractorsTableContext = createContext<IAssignContractorsTableContext>({
  tagsFilter: [],
  setTagsFilter: () => {},

  searchQuery: '',
  setSearchQuery: () => {},
})
